<script>
import settingsMixin from '@/views/Admin/Config/Settings/Common/settingsMixin';
import SettingsPage from '@/views/Admin/Config/Settings/Common/SettingsPage';
import SettingsForm from '@/views/Admin/Config/Settings/Common/SettingsForm';

export default {
    components: { SettingsForm, SettingsPage },
    mixins: [settingsMixin],
    props: [],

    data() {
        return {
            settingPage: 'siteCompletion',
            settingName: 'settingSiteCompletion'
        };
    },

    methods: {
        saveCompletion() {
            const settings = {
                siteCompletionButtonText: this.settings.siteCompletionButtonText,
                siteCompletionDialogButtonText: this.settings.siteCompletionDialogButtonText,
                siteCompletionScheduleUrl: this.settings.siteCompletionScheduleUrl,
                siteCompletionScheduleNotificationTitle: this.settings.siteCompletionScheduleNotificationTitle,
                siteCompletionScheduleNotificationText: this.settings.siteCompletionScheduleNotificationText
            };

            this.saveSettings(this.settingPage, this.setPostData(`${this.settingName}`, settings));
        }
    }
};
</script>

<template>
    <SettingsPage title="Site Completion">
        <template #settingsForms>
            <SettingsForm
                :settingsLoading="settingsLoading"
                form="completionForm"
            >
                <template #form>
                    <form
                        action=""
                        method="POST"
                        id="completionForm"
                        @submit.prevent="saveCompletion"
                        v-if="!settingsLoading && settings"
                    >
                        <v-text-field
                            label="Sidebar Button Text"
                            name="siteCompletionButtonText"
                            v-model="settings.siteCompletionButtonText"
                            outlined
                        />
                        <v-text-field
                            label="Dialog Button Text"
                            name="siteCompletionDialogButtonText"
                            v-model="settings.siteCompletionDialogButtonText"
                            outlined
                        />
                        <v-text-field
                            label="Schedule URL"
                            name="siteCompletionScheduleUrl"
                            v-model="settings.siteCompletionScheduleUrl"
                            outlined
                        />
                        <v-text-field
                            label="Schedule Notification Title"
                            name="siteCompletionScheduleNotificationTitle"
                            v-model="settings.siteCompletionScheduleNotificationTitle"
                            outlined
                        />
                        <v-textarea
                            label="Schedule Notification Text"
                            name="siteCompletionScheduleNotificationText"
                            v-model="settings.siteCompletionScheduleNotificationText"
                            outlined
                        />
                    </form>
                </template>
            </SettingsForm>
        </template>
    </SettingsPage>
</template>

